import {useEffect, useState, type RefObject} from "react";

export function useIsTruncated(ref: RefObject<HTMLElement | null>): boolean {
	const [isTruncated, setIsTruncated] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const measure = () => setIsTruncated(el.scrollWidth > el.clientWidth);
		measure();

		const ro = new ResizeObserver(measure);
		ro.observe(el);
		// Re-measure when text/children change without resizing the element (e.g. in-place data updates).
		const mo = new MutationObserver(measure);
		mo.observe(el, {childList: true, characterData: true, subtree: true});
		// Re-measure once Inter finishes loading — content width changes with no resize event.
		let mounted = true;
		document.fonts?.ready.then(() => {
			if (mounted) measure();
		}).catch(() => {});

		return () => {
			mounted = false;
			ro.disconnect();
			mo.disconnect();
		};
	}, [ref]);

	return isTruncated;
}
